// import sheetSelectModal from "@/views/menu/sheet/sheetSelectModal.vue"; // 局部加载会死循环

export default {
    components: {
        // sheetSelectModal
    },
    props: {},
    data () {
        return {
            showSheetSelectModal: false,

            dshRenderName: undefined
        };
    },
    computed: {
        dshRender () {
            return this[this.dshRenderName];
        }
    },
    created () {},
    methods: {
        /* ------ 工作表列表框相关 --------- */
        // 打开列表模态框
        openSheetSelectModal () {
            this.dshRenderName = "sheetSelectModalRender";
            this.showSheetSelectModal = true;
        },
        // 关闭列表模态框
        closeSheetSelectModal () {
            this.dshRenderName = undefined;
            this.showSheetSelectModal = false;
        },
        toggleSheetSelectModal (bool) {
            this.showSheetSelectModal = bool;
        },

        // 列表选择框渲染函数
        sheetSelectModalRender (h, params) {
            return this.showSheetSelectModal
                ? h("sheet-select-modal", {
                    props: {
                        value: this.showSheetSelectModal,
                        multiple: this.multiple,
                        useCreate: this.useCreate,
                        defaultModObj: this.sheetSelectModObj,
                        propsObj: this.sheetSelectPropsObj,
                        defaultSearchParams: this.sheetSelectSearchParams
                    },
                    on: {
                        input: this.toggleSheetSelectModal,
                        selectRow: this.selectRowCb,
                        batchSelect: this.batchSelectCb
                    }
                })
                : undefined;
        },
        // 选择一条后的回调
        selectRowCb (dataItem) {

        },
        // 批量选择后的回调
        batchSelectCb (ids, list) {

        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/sheet/sheetSelectRenderMixin.js